import { RouteComponentProps } from "@reach/router";
import Page from "components/Page";
import React from "react";

import Logo from "../../assets/Logo.png";

export const PdfFooterPage = (props: RouteComponentProps) => (
  <Page isPublic>
    <Footer />
  </Page>
);

const Footer = () => (
  <div className="PdfFooterPage">
    <div className="ReportFooter"></div>
  </div>
);
